import { useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { ABANDONED } from "../../data/adminData";
import { fmt } from "../../data/store";
import { PageTitle, Table, Badge, Btn, dt, Card } from "./ui";

export default function AbandonedCarts() {
  const [list, setList] = useState(ABANDONED);
  const remind = (id) => {
    setList((p) => p.map((c) => (c.id === id ? { ...c, reminded: true } : c)));
    toast.success("Atgādinājuma e-pasts nosūtīts (DEMO)", { description: "Ar personalizētu –5% kodu groza atjaunošanai." });
  };
  const total = list.reduce((s, c) => s + c.value, 0);
  return (
    <div data-testid="admin-abandoned">
      <PageTitle>Pamestie grozi ({list.length})</PageTitle>
      <Card className="p-4 mb-4 flex flex-wrap gap-8">
        <div><div className="text-xs uppercase tracking-widest text-[#6B6B6B] font-bold">Potenciālie ieņēmumi</div><div className="text-xl font-extrabold">{fmt(total)}</div></div>
        <div><div className="text-xs uppercase tracking-widest text-[#6B6B6B] font-bold">Atgūšanas līmenis (30 d.)</div><div className="text-xl font-extrabold text-[#1E9E45]">23%</div></div>
        <div><div className="text-xs uppercase tracking-widest text-[#6B6B6B] font-bold">Automātiskie atgādinājumi</div><div className="text-xl font-extrabold">Ieslēgti (pēc 4 h)</div></div>
      </Card>
      <Table head={["E-pasts", "Preces grozā", "Vērtība", "Pamests", "Atgādinājums", ""]}>
        {list.map((c) => (
          <tr key={c.id} className="border-b border-[#F5F5F5] hover:bg-[#F5F5F5]" data-testid={`abandoned-row-${c.id}`}>
            <td className="p-3 font-semibold">{c.email}</td>
            <td>{c.items} gab.</td>
            <td className="font-bold">{fmt(c.value)}</td>
            <td className="text-[#6B6B6B]">{dt(c.date)}</td>
            <td><Badge color={c.reminded ? "green" : "gray"}>{c.reminded ? "Nosūtīts" : "Nav sūtīts"}</Badge></td>
            <td className="p-3">
              {!c.reminded && <Btn variant="red" onClick={() => remind(c.id)} data-testid={`abandoned-remind-${c.id}`} className="flex items-center gap-1"><Mail size={12} /> Sūtīt atgādinājumu</Btn>}
            </td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
